/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

export enum CookieGroup {
  C0001 = "C0001", // Strictly Necessary - always enabled
  C0002 = "C0002", // Performance
  C0003 = "C0003", // Functional
  C0004 = "C0004", // Advertising
}

export const DEFAULT_COOKIE_GROUPS = [CookieGroup.C0001];
